export var calcFormatSingleItem = function calcFormatSingleItem(item, nameProperty, extraProps) {
  var id = String((item == null ? void 0 : item.id) || '');
  var result = {
    id: id,
    name: String((item == null ? void 0 : item[nameProperty]) || ''),
    value: String((item == null ? void 0 : item[nameProperty]) || '')
  };
  if (Array.isArray(extraProps)) {
    extraProps.forEach(function (prop) {
      if (prop && (item == null ? void 0 : item[prop]) !== undefined) {
        result[prop] = item[prop];
      }
    });
  }
  return result;
};
export var createUrlDataObject = function createUrlDataObject(path, search) {
  var searchParams = new URLSearchParams(search);
  var existingFilters = searchParams.get('filters') ? searchParams.get('filters').split('+') : [];
  return {
    existingFilters: existingFilters,
    path: path,
    searchParams: searchParams
  };
};
export var formatData = function formatData(items) {
  var nameProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var onError = arguments.length > 3 ? arguments[3] : undefined;
  if (!Array.isArray(items)) {
    return [];
  }
  try {
    return items.map(function (item) {
      return calcFormatSingleItem(item, nameProperty, extraProps);
    });
  } catch (error) {
    onError(error);
    return [];
  }
};
export var parseUrl = function parseUrl(urlString, location) {
  if (urlString.match(/^https?:\/\//)) {
    return new URL(urlString);
  }
  if (urlString.startsWith('//')) {
    return new URL("http:".concat(urlString));
  }
  var origin = (location == null ? void 0 : location.origin) || "".concat(location == null ? void 0 : location.protocol, "//").concat(location == null ? void 0 : location.host);
  var fullUrl = urlString.startsWith('/') ? "".concat(origin).concat(urlString) : "".concat(origin, "/").concat(urlString);
  return new URL(fullUrl);
};
export var slugfyUrl = function slugfyUrl(input) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  if (typeof input !== 'string') {
    return '';
  }
  var escapedSeparator = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return input.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\w-]/g, separator).replace(new RegExp("".concat(escapedSeparator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(escapedSeparator, "+|").concat(escapedSeparator, "+$"), 'g'), '');
};